const DEFAULT_LANGUAGE = 'es';

export { DEFAULT_LANGUAGE };
